module.exports = __webpack_public_path__ + "img/2-2.e345f90b.jpg";